export const materiasIMEITA = [
	{ label: 'Matemática', value: 'Matemática' },
	{ label: 'Inglês', value: 'Inglês' },
	{ label: 'Física', value: 'Física' },
	{ label: 'Português', value: 'Português' },
	{ label: 'Química', value: 'Química' },
];
